module.exports = __webpack_public_path__ + "img/issuing-sample-process-4.11ff9a08.png";